import { StepCardVariableInput as SLStepCardVariableInput } from "@skylead/component-library"
import React from "react"
import { useSelector } from "react-redux"

import dataUtils from "../../../utils/data/data-utils"
import { useGlobalTranslation } from "../../../utils/hook"

const StepCardVariableInput = ({
  onVariableSelect,
  tag,
  hideReplacement = false,
  allValues = [],
  value,
  activeMessageIndex,
  handleChange,
  inputValue = "",
  disabledButton,
  parseTag = false,
}) => {
  const { formErrors, selectedNode } = useSelector(state => ({
    formErrors: state.forms.formErrors,
    selectedNode: state.campaign.selectedNode,
  }))
  const { tt } = useGlobalTranslation()

  return (
    <SLStepCardVariableInput
      onVariableSelect={onVariableSelect}
      tag={tag}
      hideReplacement={hideReplacement}
      allValues={allValues}
      value={value}
      activeMessageIndex={activeMessageIndex}
      handleChange={handleChange}
      inputValue={inputValue}
      disabledButton={disabledButton}
      parseTag={parseTag}
      showTagReplacement={dataUtils.showTagReplacement}
      formErrors={formErrors}
      selectedNode={selectedNode}
      tt={tt}
    />
  )
}

// StepCardVariableInput.propTypes = {
//   onVariableSelect: PropTypes.func.isRequired,
//   tag: PropTypes.string.isRequired,
//   hideReplacement: PropTypes.bool,
//   allValues: PropTypes.instanceOf(Array),
//   value: PropTypes.string.isRequired,
//   activeMessageIndex: PropTypes.number,
//   handleChange: PropTypes.func.isRequired,
//   inputValue: PropTypes.string,
//   disabledButton: PropTypes.bool.isRequired,
//   parseTag: PropTypes.bool,
// }

export default StepCardVariableInput
